<template>
  <div>
    <div class="vactivitycontent" :class="{'pc': !isPhone}">
      <pcheader v-show="!isPhone" :myflags="!isPhone"></pcheader>
      <div class="topbox" v-show="isPhone">
        <img class="banner" ref="banner" src="@/assets/images/vactivitybanner.jpg" alt="">
        <div class="title">
          <img src="@/assets/images/icon-vatitle.png" alt="">
          <p v-show="myactivity" class="myactivity" @click="myvolunteer">我的活动</p>
        </div>
      </div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="进行中" name="first">
        </el-tab-pane>
        <el-tab-pane label="未开始" name="second">
        </el-tab-pane>
        <el-tab-pane label="已结束" name="third">
        </el-tab-pane>
      </el-tabs>
      <div class="bscroll" v-show="topheight" :style="{top: topheight + 'px'}" ref="bscroll">
        <div class="bscroll-container">
          <div class="innerbox clearfix">
            <div class="listitem" @click="selectdetail(item.id, item.isenroll)" v-for="(item, index) in activityList" :key="index">
              <a>
                <img :src="getImage(item.image)" alt="">
                <div class="libg"></div>
                <div class="title">{{item.name}}</div>
                <span>{{item.isenroll === 1 ? '查看' : '报名'}}</span>
              </a>
            </div>
            <div class="nodata" v-if="activityList&&activityList.length==0">暂无数据</div>
          </div>
          <div class="listpage" v-show="!isshowpage">
            <el-pagination
              background
              layout="prev, pager, next"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="page"
              :page-size="limit"
              :total="total">
            </el-pagination>
          </div>
          <p class="drop-down" v-if="nodata">-- 我是有底线的 --</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import BScroll from 'better-scroll'
import Pcheader from '@/views/common/pcheader'
export default {
  name: 'volunteeractivity',
  components: {
    Pcheader
  },
  data () {
    return {
      activityList: [],
      topHeight: '',
      topheight: '',
      activeName: 'first',
      page: 1,
      limit: 20,
      status: '进行中',
      total: 0,
      nodata: false,
      myactivity: true,
      isshowpage: true,
      isPhone: false, // 是否是PC端/移动端
      screenWidth: 0 // 屏幕分辨率
    }
  },
  created () {
  },
  watch: {
    // 监听首页banner的高度
    topHeight (val) {
      if (val) {
        this.topheight = parseInt(val)
      }
    }
  },
  mounted () {
    let _this = this
    // 判断是否从微信小程序进入
    if (this.$cookie.get('weixinflag') === 'true') {
      this.myactivity = false
    } else {
      this.myactivity = true
    }
    this.screenWidth = document.body.clientWidth
    if (this.screenWidth < 768) {
      this.isPhone = true
      this.$refs.banner.onload = function () {
        _this.topHeight = this.height
      }
      this.isshowpage = true
      this.getList()
      this.scrollFn()
    } else {
      this.isPhone = false
      this.isshowpage = false
      this.topHeight = '160'
      this.getList()
    }
    window.onresize = () => {
      _this.screenResize()
    }
  },
  methods: {
    screenResize () {
      if (document.body.clientWidth < 768) {
        this.isPhone = true
      } else {
        this.isPhone = false
      }
    },
    // 获取地址栏参数
    getQueryStringRegExp (name) {
      var reg = new RegExp('(^|\\?|&)' + name + '=([^&]*)(\\s|&|$)', 'i')
      if (reg.test(location.href)) {
        return unescape(RegExp.$2.replace(/\+/g, ' '))
      } else {
        return ''
      }
    },
    selectdetail (val, isFlag) {
      this.$router.push({
        path: `/activitydetail/${val}`,
        query: {isenroll: isFlag, museumCode: this.$cookie.get('museumCode')}
      })
    },
    myvolunteer () {
      this.$router.push({
        path: `/myvolunteeractivity`,
        query: {museumCode: this.$cookie.get('museumCode')}
      })
    },
    handleSizeChange (val) {
      // console.log("\u6BCF\u9875 ".concat(val, " \u6761"));
    },
    handleCurrentChange (val) {
      this.page = val
      this.getList()
    },
    getList () {
      this.$http({
        url: this.$http.adornUrl(`/api/volunteer/web/activity/one-museum?museumCode=` + this.$cookie.get('museumCode') + `&page=` + this.page + `&limit=` + this.limit + `&status=` + this.status),
        method: 'get'
      }).then((res) => {
        if (res) {
          if (res.data.status === 200) {
            this.nodata = false
            this.total = res.data.data.total
            if (this.total === 0) {
              this.isshowpage = true
              this.activityList = []
              return false
            } else {
              let isenroll = ''
              if (this.status === '已结束') {
                isenroll = 1
              } else {
                isenroll = 0
              }
              for (let i = 0; i < res.data.data.rows.length; i++) {
                res.data.data.rows[i].isenroll = isenroll
              }
              if (this.screenWidth < 768) {
                this.isshowpage = true
                if (this.page === 1) {
                  this.activityList = res.data.data.rows
                } else {
                  this.activityList = this.activityList.concat(res.data.data.rows)
                }
              } else {
                this.isshowpage = false
                this.activityList = res.data.data.rows
              }
            }
          } else {
            this.$message.error(res.data.message)
          }
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    getImage (val) {
      let imgArr = val.split(';')
      return window.SITE_CONFIG.baseUrl + '/api/volunteer/web/images/' + imgArr[0]
    },
    // 获取指定状态的列表
    handleClick (tab) {
      this.page = 1
      this.status = tab.label
      this.getList()
    },
    // 上拉加载
    scrollFn () {
      this.$nextTick(() => {
        if (!this.scroll) {
          this.scroll = new BScroll(this.$refs.bscroll, {
            click: true,
            scrollY: true,
            probeType: 3
          })
        } else {
          this.scroll.refresh()
        }
        this.scroll.on('scroll', (pos) => {
        })
        // touchEnd（手指离开以后触发） 通过这个方法来监听下拉刷新
        this.scroll.on('touchEnd', (pos) => {
          // 上拉加载 总高度>下拉的高度+10 触发加载更多
          if (this.scroll.maxScrollY > pos.y + 10) {
            // console.log('加载更多')
            let pagetotal = Math.ceil(this.total / this.limit)
            if (this.page < pagetotal) {
              this.page++
              this.getList()
            } else {
              this.nodata = true
            }
            this.scroll.refresh()
          }
        })
      })
    }
  }
}
</script>

<style lang="scss">
  .fl{
    float: left;
  }
  .fr{
    float: right;
  }
  .vactivitycontent{
    -webkit-overflow-scrolling:touch;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 0;
    background: #fff;
    overflow: hidden;
    overflow-y: auto;
    .topbox{
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
      position: relative;
      overflow: hidden;
      z-index: 4;
      .banner{
        width: 100%;
        vertical-align: top;
      }
      .title{
        text-align: center;
        position: absolute;
        width:60%;
        top: 22%;
        left: 50%;
        margin: 0 0 0 -30%;
        z-index: 2;
        img{
          width: 100%;
          vertical-align: top;
        }
        .myactivity{
          display: inline-block;
          font-size: 14px;
          margin: 10px 0 0;
          padding: 0 15px;
          text-align: center;
          color: #901212;
          background: #fff;
          height: 24px;
          line-height: 24px;
          -webkit-border-radius: 24px;
          -moz-border-radius: 24px;
          border-radius: 24px;
        }
      }
    }
    .el-tabs{
      padding: 0 20px;
      margin-top: -15px;
      position: relative;
      z-index: 4;
      .el-tabs__header{
        margin-bottom: 0;
        background: #ffffff;
        -webkit-border-radius: 30px;
        -moz-border-radius: 30px;
        border-radius: 30px;
        box-shadow: 0 0 10px rgba(67,39,16,0.3);
        .el-tabs__nav-wrap::after{
          display: none;
        }
        .el-tabs__nav{
          width: 100%;
          .el-tabs__active-bar{
            display: none;
          }
          .el-tabs__item{
            width: 33.3333333%!important;
            padding: 0;
            text-align: center;
            height: 36px;
            line-height: 36px;
            color: #999;
            &.is-active{
              color: #a90a1a;
            }
            &#tab-second{
              position: relative;
              &::after,&::before{
                content: '';
                display: block;
                width: 1px;
                height: 18px;
                background: #ddd;
                position: absolute;
                top: 9px;
              }
              &::before{}
              left: 0;
              &::after{
                right: 0;
              }
            }
          }
        }
      }
      .el-tabs__content{
        margin: 30px 0 0;
        display: none;
      }
    }
    .bscroll{
      position: fixed;
      right: 0px;
      left: 0px;
      bottom: 0;
      overflow: hidden;
      z-index: 1;
      padding: 0px 20px 20px;
      .innerbox{
        padding: 50px 0 0;
      }
      .nodata,
      .drop-down{
        text-align: center;
        padding: 50px 0;
        color: #444;
      }
      .drop-down{
        padding: 00px 0 40px;
      }
      .listitem{
        margin-bottom: 30px;
        a{
          display: block;
          position: relative;
          -webkit-border-radius: 6px;
          -moz-border-radius: 6px;
          border-radius: 6px;
          overflow: hidden;
          width: 100%;
          height: 0px;
          padding-bottom: 40%;
          img{
            vertical-align: middle;
            background-size: cover;
            background-repeat: no-repeat;
            top: 0;
            position: absolute;
            width: 100%;
            height: auto;
          }
          .libg{
            width: 100%;
            height: 50%;
            position: absolute;
            left: 0;
            bottom: 0;
            z-index: 2;
            background: -webkit-linear-gradient(top, rgba(0,0,0,0) , rgba(0,0,0,0.6)); /* Safari 5.1 - 6.0 */
            background: -o-linear-gradient(bottom, rgba(0,0,0,0), rgba(0,0,0,0.6)); /* Opera 11.1 - 12.0 */
            background: -moz-linear-gradient(bottom, rgba(0,0,0,0), rgba(0,0,0,0.6)); /* Firefox 3.6 - 15 */
            background: linear-gradient(to bottom, rgba(0,0,0,0) , rgba(0,0,0,0.6)); /* 标准的语法 */
            filter: progid:DXImageTransform.Microsoft.gradient(GradientType=1, startColorstr=rgba(0,0,0,0), endColorstr=rgba(0,0,0,0.6));
          }
          .title{
            width: 100%;
            position: absolute;
            bottom: 0;
            left: 0;
            z-index: 3;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            color: #fff;
            padding: 8px 28% 10px 10px;
          }
          span{
            display: block;
            position: absolute;
            right: 3%;
            color: #fff;
            padding: 4px 18px 2px;
            -webkit-border-radius: 20px;
            -moz-border-radius: 20px;
            border-radius: 20px;
            bottom: 10px;
            z-index: 4;
            background: -webkit-linear-gradient(left, #7b0000 , #ef6161); /* Safari 5.1 - 6.0 */
            background: -o-linear-gradient(right, #7b0000, #ef6161); /* Opera 11.1 - 12.0 */
            background: -moz-linear-gradient(right, #7b0000, #ef6161); /* Firefox 3.6 - 15 */
            background: linear-gradient(to right, #7b0000 , #ef6161); /* 标准的语法 */
            filter: progid:DXImageTransform.Microsoft.gradient(GradientType=1, startColorstr=#7b0000, endColorstr=#ef6161);
          }
        }
      }
    }
    &.pc{
      .el-tabs{
        width: 1200px;
        margin: 30px auto 30px;
        padding: 0;
        .el-tabs__header{
          box-shadow: 0 0 10px rgba(67,39,16,0.1);
        }
      }
      .bscroll{
        top: 160px;
        overflow-y: auto;
        .bscroll-container{
          width: 1200px;
          margin: 0 auto;
          .innerbox{
            padding: 20px 0 0;
            margin: 0 -10px;
            .listitem{
              width: 25%;
              float: left;
              padding: 0 10px;
              margin: 0 0 20px 0;
              a{
                padding-bottom: 55%;
                background: #eee;
              }
            }
          }
          .listpage{
            padding: 30px 0 40px;
            text-align: center;
            .el-pagination.is-background .el-pager li:not(.disabled).active{
              background: #a11b00;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/volunteeractivity.vue